/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';
var __iconNode = [["path", {
  d: "M20 6 9 17l-5-5",
  key: "1gmf2c"
}]];
var Check = createLucideIcon("Check", __iconNode);
export { __iconNode, Check as default };